@if (pages > 1) {
    <div class="flex justify-end mb-2 mr-4 sm:mr-0">
        <span class="text-gray-400 text-sm">Count: {{ maxCount }}</span>
    </div>
}
@if (pages > 1) {
    <nav class="flex items-center justify-between border-t border-blue-200 px-4 sm:px-0">
        <div class="-mt-px flex w-0 flex-1 group">
            @if (currentPage !== 1) {
                <button
                    (click)="previous()"
                    href="#"
                    class="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-blue-300 group-hover:text-blue-700"
                >
                    <svg
                        class="mr-3 h-5 w-5 text-gray-400 group-hover:text-blue-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a.75.75 0 01-.75.75H4.66l2.1 1.95a.75.75 0 11-1.02 1.1l-3.5-3.25a.75.75 0 010-1.1l3.5-3.25a.75.75 0 111.02 1.1l-2.1 1.95h12.59A.75.75 0 0118 10z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    Previous
                </button>
            }
        </div>
        <div class="hidden md:-mt-px md:flex">
            @for (page of paginationArry; track $index) {
                <div>
                    @if (page !== '...') {
                        <a
                            href="#"
                            href="#"
                            routerLink="./"
                            (click)="onNumberClick()"
                            [queryParams]="getQueryParams(page)"
                            [ngClass]="isActivePage(page)"
                            >{{ page }}</a
                        >
                    }
                    @if (page === '...') {
                        <span class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500"
                            >...</span
                        >
                    }
                </div>
            }
        </div>
        <div class="-mt-px flex w-0 flex-1 justify-end group">
            @if (currentPage !== pages) {
                <button
                    (click)="next()"
                    class="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-blue-300 group-hover:text-blue-700"
                >
                    Next
                    <svg
                        class="ml-3 h-5 w-5 text-gray-400 group-hover:text-blue-700"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            }
        </div>
    </nav>
}
